import * as React from 'react';
import type { SVGProps } from 'react';

const IconAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      d="M12 0C5.381 0 0 5.381 0 12s5.381 12 12 12 12-5.381 12-12S18.619 0 12 0Zm0 6.872a3.774 3.774 0 0 1 3.764 3.764A3.774 3.774 0 0 1 12 14.4a3.774 3.774 0 0 1-3.764-3.764A3.774 3.774 0 0 1 12 6.872ZM5.432 19.276v-.556a2.906 2.906 0 0 1 2.905-2.905h7.326a2.905 2.905 0 0 1 2.905 2.905v.556A9.795 9.795 0 0 1 12 21.802a9.795 9.795 0 0 1-6.568-2.526Z"
      fill="currentColor"
    />
  </svg>
);

export default IconAvatar;
